import React from "react";
import { headingLabel, headingTitle } from "../../config/site";

type SectionHeadingProps = {
    label: string;
    title: string;
};

export function SectionHeading({ label, title }: SectionHeadingProps) {
    return (
        <div className="mb-[60px] max-lg:mb-3">
            <p className={headingLabel}>{label}</p>
            <h2 className={headingTitle}>{title}</h2>
        </div>
    );
}
